export enum UserRoles {
  ROLE_EMPLOYEE_ADMIN = 'ROLE_EMPLOYEE_ADMIN',
  ROLE_EMPLOYEE_MANAGER = 'ROLE_EMPLOYEE_MANAGER',
  ROLE_EMPLOYEE_WORKER = 'ROLE_EMPLOYEE_WORKER',
  ROLE_EMPLOYEE_CLIENT = 'ROLE_EMPLOYEE_CLIENT',
  ROLE_EMPLOYEE_EXTERNAL = 'ROLE_EMPLOYEE_EXTERNAL',
}

export const ACTIVE_USER_ROLES: UserRoles[] = [
  UserRoles.ROLE_EMPLOYEE_ADMIN,
  UserRoles.ROLE_EMPLOYEE_MANAGER
];
